/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

var browserSupport = __webpack_require__(337);

// expose for use from outside this scope //
window.MyWebsiteShowroomIntegrator =
    browserSupport.canRunShowroom() ?
    __webpack_require__(338).integratorApi :
    {
        // If browser is not supported, inline some basic code that's guaranteed
        // to work on any outdated browser
        /** @see IntegratorApi#init */
        init: function(container, baseShowroomUrl, locale, host, config) {
            // set the content of the container to be an iframe //
            while (container.lastChild) {
                container.removeChild(container.lastChild);
            }

            var iframe = document.createElement("iframe");
            iframe.style.padding = 'none';
            iframe.style.border = 'none';
            iframe.style.padding = 'none';
            iframe.style.height = '755px';
            iframe.style.width = '100%';
            container.appendChild(iframe);

            iframe.src = baseShowroomUrl + '?locale=' + locale + '&host=' + host;
        },
        isBrowserSupported: function() {
            return false;
        }
    };

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Coder = (function () {
    function Coder() {
    }
    Coder.prototype.encode = function (rawObject) {
        return btoa(JSON.stringify(rawObject));
    };
    Coder.prototype.decode = function (encodedData) {
        return JSON.parse(atob(encodedData));
    };
    return Coder;
}());
exports.Coder = Coder;
;


/***/ }),

/***/ 314:
/***/ (function(module, exports) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getOffset(elem) {
    var top = 0, left = 0;
    do {
        top += elem.offsetTop || 0;
        left += elem.offsetLeft || 0;
        elem = elem.offsetParent;
    } while (elem);
    return {
        top: top,
        left: left
    };
}
exports.getOffset = getOffset;
function contains(haystack, needle) {
    do {
        if (needle === haystack) {
            return true;
        }
        needle = needle.parentElement;
    } while (needle);
    return false;
}
exports.contains = contains;


/***/ }),

/***/ 337:
/***/ (function(module, exports) {

/**
 * Checks if current browser is supported for running the app
 *
 * !! This is run in the bootstrap, so no TypeScript or ES5+ syntax here
 */
module.exports = {
    canRunShowroom: function () {
        // check browser support; we need flexbox and es5 support //
        var testEl = document.createElement('div'),
            props = ['flexWrap', 'FlexWrap', 'WebkitFlexWrap', 'MozFlexWrap', 'msFlexWrap'],
            cssPrefixes = ['', '-webkit-', '-moz-', '-ms-'],
            supportsFlex = false,
            supportsEs5 = Function.prototype.hasOwnProperty('bind'),
            i;

        for(i = 0; i < props.length; i++) {
            if (testEl.style[props[i]] !== undefined) {
                supportsFlex = true;
                break;
            }
        }

        // extra check for browsers with wrong flexbox implementations (ex.: IE10) //
        if (supportsFlex) {
            supportsFlex = false;
            for (i = 0; i < cssPrefixes.length; i++) {
                testEl.style.display = cssPrefixes[i] + "flex";
                if (testEl.style.display === (cssPrefixes[i] + "flex")) {
                    supportsFlex = true;
                    break;
                }
            }
        }

        return supportsFlex && supportsEs5;
    }
};

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Coder_1 = __webpack_require__(7);
var ShowroomFrame_1 = __webpack_require__(339);
var showroomInstance = null;
var IntegratorApi = (function () {
    function IntegratorApi() {
    }
    IntegratorApi.prototype.encodeObject = function (rawObject) {
        return (new Coder_1.Coder).encode(rawObject);
    };
    IntegratorApi.prototype.decodeObject = function (encodedData) {
        return (new Coder_1.Coder).decode(encodedData);
    };
    IntegratorApi.prototype.init_1 = function (container, baseShowroomUrl, locale, host, config) {
        if (showroomInstance !== null) {
            throw new Error('init was already called before');
        }
        var iframeStyle = {
            height: '0'
        };
        var iframe = this.prepareContainerAndIframe(container, iframeStyle);
        showroomInstance = new ShowroomFrame_1.ShowroomFrame(iframe, baseShowroomUrl +
            '?locale=' + locale +
            '&host=' + host +
            '&initConfig=' + this.encodeObject(config));
        showroomInstance.load();
    };
    IntegratorApi.prototype.init_2 = function (container, baseShowroomUrl, locale, config) {
        if (showroomInstance !== null) {
            throw new Error('init was already called before');
        }
        var iframeStyle = {};
        if (config.hasOwnProperty('host')) {
            switch (config.host) {
                case 'diyeditor':
                    iframeStyle.height = '100%';
                    iframeStyle.position = 'relative';
                    break;
                default:
                    iframeStyle.height = '0';
                    break;
            }
        }
        var iframe = this.prepareContainerAndIframe(container, iframeStyle);
        showroomInstance = new ShowroomFrame_1.ShowroomFrame(iframe, this.makeFrameUrl(baseShowroomUrl, locale, config));
        showroomInstance.load();
    };
    IntegratorApi.prototype.init = function () {
        this.init_1.apply(this, arguments);
    };
    IntegratorApi.prototype.registerSelectCallback = function (callback) {
        if (showroomInstance === null) {
            throw new Error('no showroom instance is initialized');
        }
        showroomInstance.addSelectCallback(callback);
    };
    IntegratorApi.prototype.registerErrorCallback = function (callback) {
        if (showroomInstance === null) {
            throw new Error('no showroom instance is initialized');
        }
        showroomInstance.addErrorCallback(callback);
    };
    IntegratorApi.prototype.registerOpenOverlayCallback = function (callback) {
        if (showroomInstance === null) {
            throw new Error('no showroom instance is initialized');
        }
        showroomInstance.addOpenOverlayCallback(callback);
    };
    IntegratorApi.prototype.registerCloseOverlayCallback = function (callback) {
        if (showroomInstance === null) {
            throw new Error('no showroom instance is initialized');
        }
        showroomInstance.addCloseOverlayCallback(callback);
    };
    IntegratorApi.prototype.isBrowserSupported = function () {
        return true;
    };
    IntegratorApi.prototype.changeFrameUrl = function (baseShowroomUrl, locale, config) {
        if (showroomInstance) {
            showroomInstance.setFrameUrl(this.makeFrameUrl(baseShowroomUrl, locale, config));
        }
    };
    IntegratorApi.prototype.emptyContainer = function (container) {
        while (container.lastChild) {
            container.removeChild(container.lastChild);
        }
    };
    IntegratorApi.prototype.createShowroomIframe = function (iframeStyle) {
        var iframe = document.createElement("iframe");
        iframe.style.padding = 'none';
        iframe.style.border = 'none';
        iframe.style.width = '100%';
        iframe.style.height = '0';
        for (var prop in iframeStyle) {
            if (iframeStyle.hasOwnProperty(prop)) {
                iframe.style[prop] = iframeStyle[prop];
            }
        }
        return iframe;
    };
    IntegratorApi.prototype.prepareContainerAndIframe = function (container, iframeStyle) {
        this.emptyContainer(container);
        var iframe = this.createShowroomIframe(iframeStyle);
        container.appendChild(iframe);
        return iframe;
    };
    IntegratorApi.prototype.makeFrameUrl = function (baseShowroomUrl, locale, config) {
        return baseShowroomUrl +
            (baseShowroomUrl.indexOf("?") !== -1 ? "&" : "?") + 'locale=' + locale +
            '&initConfig=' + this.encodeObject(config);
    };
    return IntegratorApi;
}());
exports.integratorApi = new IntegratorApi;


/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(314);
var ShowroomFrame = (function () {
    function ShowroomFrame(frameElement, url) {
        this.frameElement = frameElement;
        this.url = url;
        this.selectCallbacks = [];
        this.errorCallbacks = [];
        this.openOverlayCallbacks = [];
        this.closeOverlayCallbacks = [];
    }
    ShowroomFrame.prototype.load = function () {
        var _this = this;
        this.frameElement.src = this.url;
        window.addEventListener("message", function (event) {
            var message = JSON.parse(event.data);
            if (_this.frameElement.contentWindow !== event.source) {
                return;
            }
            var callbacks = [];
            switch (message.type) {
                case 'select':
                    callbacks = _this.selectCallbacks;
                    break;
                case 'error':
                    callbacks = _this.errorCallbacks;
                    break;
                case 'resize':
                    _this.frameElement.style.height = (message.data) + 'px';
                    break;
                case 'scroll':
                    var offset = message.data.offset;
                    if (message.data.includeIframeOffset) {
                        var iframeOffset = dom_1.getOffset(_this.frameElement);
                        offset += iframeOffset.top;
                    }
                    window.scrollTo(0, offset);
                    break;
                case 'navigate':
                    if (message.data === 'back') {
                        window.history.back();
                    }
                    break;
                case 'openoverlay':
                    callbacks = _this.openOverlayCallbacks;
                    break;
                case 'closeoverlay':
                    callbacks = _this.closeOverlayCallbacks;
                    break;
                default:
                    break;
            }
            for (var i = 0; i < callbacks.length; i++) {
                callbacks[i].call(null, message.data);
            }
        }, false);
    };
    ShowroomFrame.prototype.setFrameUrl = function (url) {
        this.url = url;
        this.frameElement.src = url;
    };
    ShowroomFrame.prototype.addSelectCallback = function (handlerCallback) {
        this.selectCallbacks.push(handlerCallback);
    };
    ShowroomFrame.prototype.addErrorCallback = function (handlerCallback) {
        this.errorCallbacks.push(handlerCallback);
    };
    ShowroomFrame.prototype.addOpenOverlayCallback = function (handlerCallback) {
        this.openOverlayCallbacks.push(handlerCallback);
    };
    ShowroomFrame.prototype.addCloseOverlayCallback = function (handlerCallback) {
        this.closeOverlayCallbacks.push(handlerCallback);
    };
    return ShowroomFrame;
}());
exports.ShowroomFrame = ShowroomFrame;
;


/***/ })

/******/ });


// WEBPACK FOOTER //
// host.js